import { listImageTypes } from '@frontend/services/imageTypesApi';

let cache = null;

export async function loadImageTypeCatalog() {
  if (cache) return cache;
  try {
    cache = await listImageTypes();
  } catch {
    cache = [];
  }
  return cache;
}

export function getTypeDirection(catalog, key) {
  if (!Array.isArray(catalog) || !key) return null;
  const hit = catalog.find(
    (t) => t.key === key || (Array.isArray(t.aliases) && t.aliases.includes(key)),
  );
  return (hit && hit.default_ai_direction) || null;
}
